import { MaterialType } from "../../../types/materials";
import { EditorialTextBaseColors, EditorialTextColors } from "./types";

export const colorScheme: Record<EditorialTextColors, string> = {
  [EditorialTextBaseColors.LIGHT]: "bg-neutral-light",
  [EditorialTextBaseColors.NEUTRAL]: "bg-neutral",
  [EditorialTextBaseColors.PRIMARY]: "bg-primary",
  [MaterialType.Wood]: "bg-wood",
  [MaterialType.Stone]: "bg-stone",
  [MaterialType.Glass]: "bg-glass",
  [MaterialType.Materia]: "bg-materia",
  [MaterialType.Metal]: "bg-metal",
};
